/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_AmountInputs */

const en_admin_credits_amount = /** @type {(inputs: Admin_Credits_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Admin_Credits_AmountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_amount = /** @type {((inputs?: Admin_Credits_AmountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_AmountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_amount(inputs)
});
export { admin_credits_amount as "admin.credits.amount" }